"use client"

import { ABILITY_TYPE_CONFIG, type AbilityType } from "@/lib/community/types"

/**
 * AbilityTypeBadge — colored pill indicating content type.
 * Used on every card and in detail views.
 */
export function AbilityTypeBadge({
  type,
  size = "sm",
  className = "",
}: {
  type: AbilityType
  size?: "sm" | "md"
  className?: string
}) {
  const config = ABILITY_TYPE_CONFIG[type]
  const isTeam = type === "agent-team"

  const sizeClasses = size === "sm"
    ? "px-2 py-0.5 text-micro"
    : "px-2.5 py-1 text-xs"

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium ${config.bgClass} ${config.textClass} ${sizeClasses} ${className}`}
      style={isTeam ? {
        background: `linear-gradient(135deg, ${config.hex}CC, ${"hexEnd" in config ? config.hexEnd : config.hex}CC)`,
      } : undefined}
    >
      {config.label}
    </span>
  )
}
